// source: tenant-manager.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.tenantmanager.AccountReleaseMode', null, global);
goog.exportSymbol('proto.tenantmanager.Branding', null, global);
goog.exportSymbol('proto.tenantmanager.BrandingAssetType', null, global);
goog.exportSymbol('proto.tenantmanager.DedicatedEnvPool', null, global);
goog.exportSymbol('proto.tenantmanager.GetMyTenantReply', null, global);
goog.exportSymbol('proto.tenantmanager.GetMyTenantReq', null, global);
goog.exportSymbol('proto.tenantmanager.GetMyTenantsReply', null, global);
goog.exportSymbol('proto.tenantmanager.GetMyTenantsReq', null, global);
goog.exportSymbol('proto.tenantmanager.GetSeatUsageReply', null, global);
goog.exportSymbol('proto.tenantmanager.GetSeatUsageReq', null, global);
goog.exportSymbol('proto.tenantmanager.ListTenantDedicatedEnvsReply', null, global);
goog.exportSymbol('proto.tenantmanager.ListTenantDedicatedEnvsReq', null, global);
goog.exportSymbol('proto.tenantmanager.ReleaseClosedRoomAccountsReply', null, global);
goog.exportSymbol('proto.tenantmanager.ReleaseClosedRoomAccountsReq', null, global);
goog.exportSymbol('proto.tenantmanager.SeatTier', null, global);
goog.exportSymbol('proto.tenantmanager.SetRoomDedicatedEnvReply', null, global);
goog.exportSymbol('proto.tenantmanager.SetRoomDedicatedEnvReq', null, global);
goog.exportSymbol('proto.tenantmanager.SetRoomSeatLimitsReply', null, global);
goog.exportSymbol('proto.tenantmanager.SetRoomSeatLimitsReq', null, global);
goog.exportSymbol('proto.tenantmanager.TenantInfo', null, global);
goog.exportSymbol('proto.tenantmanager.TierUsage', null, global);
goog.exportSymbol('proto.tenantmanager.UpdateBrandingReply', null, global);
goog.exportSymbol('proto.tenantmanager.UpdateBrandingReq', null, global);
goog.exportSymbol('proto.tenantmanager.UploadBrandingAssetReply', null, global);
goog.exportSymbol('proto.tenantmanager.UploadBrandingAssetReq', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.TenantInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.TenantInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.TenantInfo.displayName = 'proto.tenantmanager.TenantInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.Branding = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.Branding, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.Branding.displayName = 'proto.tenantmanager.Branding';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.GetMyTenantsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.GetMyTenantsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.GetMyTenantsReq.displayName = 'proto.tenantmanager.GetMyTenantsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.GetMyTenantsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tenantmanager.GetMyTenantsReply.repeatedFields_, null);
};
goog.inherits(proto.tenantmanager.GetMyTenantsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.GetMyTenantsReply.displayName = 'proto.tenantmanager.GetMyTenantsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.GetMyTenantReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.GetMyTenantReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.GetMyTenantReq.displayName = 'proto.tenantmanager.GetMyTenantReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.GetMyTenantReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.GetMyTenantReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.GetMyTenantReply.displayName = 'proto.tenantmanager.GetMyTenantReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.TierUsage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.TierUsage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.TierUsage.displayName = 'proto.tenantmanager.TierUsage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.GetSeatUsageReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.GetSeatUsageReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.GetSeatUsageReq.displayName = 'proto.tenantmanager.GetSeatUsageReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.GetSeatUsageReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tenantmanager.GetSeatUsageReply.repeatedFields_, null);
};
goog.inherits(proto.tenantmanager.GetSeatUsageReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.GetSeatUsageReply.displayName = 'proto.tenantmanager.GetSeatUsageReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.SetRoomSeatLimitsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.SetRoomSeatLimitsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.SetRoomSeatLimitsReq.displayName = 'proto.tenantmanager.SetRoomSeatLimitsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.SetRoomSeatLimitsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.SetRoomSeatLimitsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.SetRoomSeatLimitsReply.displayName = 'proto.tenantmanager.SetRoomSeatLimitsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.DedicatedEnvPool = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.DedicatedEnvPool, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.DedicatedEnvPool.displayName = 'proto.tenantmanager.DedicatedEnvPool';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.ListTenantDedicatedEnvsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.ListTenantDedicatedEnvsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.ListTenantDedicatedEnvsReq.displayName = 'proto.tenantmanager.ListTenantDedicatedEnvsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.ListTenantDedicatedEnvsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tenantmanager.ListTenantDedicatedEnvsReply.repeatedFields_, null);
};
goog.inherits(proto.tenantmanager.ListTenantDedicatedEnvsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.ListTenantDedicatedEnvsReply.displayName = 'proto.tenantmanager.ListTenantDedicatedEnvsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.SetRoomDedicatedEnvReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.SetRoomDedicatedEnvReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.SetRoomDedicatedEnvReq.displayName = 'proto.tenantmanager.SetRoomDedicatedEnvReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.SetRoomDedicatedEnvReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.SetRoomDedicatedEnvReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.SetRoomDedicatedEnvReply.displayName = 'proto.tenantmanager.SetRoomDedicatedEnvReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.UpdateBrandingReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.UpdateBrandingReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.UpdateBrandingReq.displayName = 'proto.tenantmanager.UpdateBrandingReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.UpdateBrandingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.UpdateBrandingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.UpdateBrandingReply.displayName = 'proto.tenantmanager.UpdateBrandingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.UploadBrandingAssetReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.UploadBrandingAssetReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.UploadBrandingAssetReq.displayName = 'proto.tenantmanager.UploadBrandingAssetReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.UploadBrandingAssetReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.UploadBrandingAssetReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.UploadBrandingAssetReply.displayName = 'proto.tenantmanager.UploadBrandingAssetReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.ReleaseClosedRoomAccountsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.ReleaseClosedRoomAccountsReq.displayName = 'proto.tenantmanager.ReleaseClosedRoomAccountsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tenantmanager.ReleaseClosedRoomAccountsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tenantmanager.ReleaseClosedRoomAccountsReply.displayName = 'proto.tenantmanager.ReleaseClosedRoomAccountsReply';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.TenantInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.TenantInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.TenantInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.TenantInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
tenantId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
ownerUserId: jspb.Message.getFieldWithDefault(msg, 3, ""),
active: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
accountLimit: jspb.Message.getFieldWithDefault(msg, 5, 0),
activeUsers: jspb.Message.getFieldWithDefault(msg, 6, 0),
currentAccounts: jspb.Message.getFieldWithDefault(msg, 7, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 8, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.TenantInfo}
 */
proto.tenantmanager.TenantInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.TenantInfo;
  return proto.tenantmanager.TenantInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.TenantInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.TenantInfo}
 */
proto.tenantmanager.TenantInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerUserId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccountLimit(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActiveUsers(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentAccounts(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.TenantInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.TenantInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.TenantInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.TenantInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOwnerUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAccountLimit();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getActiveUsers();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getCurrentAccounts();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.tenantmanager.TenantInfo.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.TenantInfo} returns this
 */
proto.tenantmanager.TenantInfo.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tenantmanager.TenantInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.TenantInfo} returns this
 */
proto.tenantmanager.TenantInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string owner_user_id = 3;
 * @return {string}
 */
proto.tenantmanager.TenantInfo.prototype.getOwnerUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.TenantInfo} returns this
 */
proto.tenantmanager.TenantInfo.prototype.setOwnerUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool active = 4;
 * @return {boolean}
 */
proto.tenantmanager.TenantInfo.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tenantmanager.TenantInfo} returns this
 */
proto.tenantmanager.TenantInfo.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int32 account_limit = 5;
 * @return {number}
 */
proto.tenantmanager.TenantInfo.prototype.getAccountLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.TenantInfo} returns this
 */
proto.tenantmanager.TenantInfo.prototype.setAccountLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 active_users = 6;
 * @return {number}
 */
proto.tenantmanager.TenantInfo.prototype.getActiveUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.TenantInfo} returns this
 */
proto.tenantmanager.TenantInfo.prototype.setActiveUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 current_accounts = 7;
 * @return {number}
 */
proto.tenantmanager.TenantInfo.prototype.getCurrentAccounts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.TenantInfo} returns this
 */
proto.tenantmanager.TenantInfo.prototype.setCurrentAccounts = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string created_at = 8;
 * @return {string}
 */
proto.tenantmanager.TenantInfo.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.TenantInfo} returns this
 */
proto.tenantmanager.TenantInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string subscription_id = 18;
 * @return {string}
 */
proto.tenantmanager.TenantInfo.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.TenantInfo} returns this
 */
proto.tenantmanager.TenantInfo.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.Branding.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.Branding.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.Branding} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.Branding.toObject = function(includeInstance, msg) {
  var f, obj = {
appName: jspb.Message.getFieldWithDefault(msg, 1, ""),
logoUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
faviconUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
poweredByEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
roomName: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.Branding}
 */
proto.tenantmanager.Branding.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.Branding;
  return proto.tenantmanager.Branding.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.Branding} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.Branding}
 */
proto.tenantmanager.Branding.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFaviconUrl(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPoweredByEnabled(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.Branding.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.Branding.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.Branding} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.Branding.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFaviconUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPoweredByEnabled();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getRoomName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string app_name = 1;
 * @return {string}
 */
proto.tenantmanager.Branding.prototype.getAppName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.Branding} returns this
 */
proto.tenantmanager.Branding.prototype.setAppName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string logo_url = 2;
 * @return {string}
 */
proto.tenantmanager.Branding.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.Branding} returns this
 */
proto.tenantmanager.Branding.prototype.setLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string favicon_url = 3;
 * @return {string}
 */
proto.tenantmanager.Branding.prototype.getFaviconUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.Branding} returns this
 */
proto.tenantmanager.Branding.prototype.setFaviconUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool powered_by_enabled = 7;
 * @return {boolean}
 */
proto.tenantmanager.Branding.prototype.getPoweredByEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tenantmanager.Branding} returns this
 */
proto.tenantmanager.Branding.prototype.setPoweredByEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string room_name = 10;
 * @return {string}
 */
proto.tenantmanager.Branding.prototype.getRoomName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.Branding} returns this
 */
proto.tenantmanager.Branding.prototype.setRoomName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.GetMyTenantsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.GetMyTenantsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.GetMyTenantsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.GetMyTenantsReq.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.GetMyTenantsReq}
 */
proto.tenantmanager.GetMyTenantsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.GetMyTenantsReq;
  return proto.tenantmanager.GetMyTenantsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.GetMyTenantsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.GetMyTenantsReq}
 */
proto.tenantmanager.GetMyTenantsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.GetMyTenantsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.GetMyTenantsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.GetMyTenantsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.GetMyTenantsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tenantmanager.GetMyTenantsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.GetMyTenantsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.GetMyTenantsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.GetMyTenantsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.GetMyTenantsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tenantsList: jspb.Message.toObjectList(msg.getTenantsList(),
    proto.tenantmanager.TenantInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.GetMyTenantsReply}
 */
proto.tenantmanager.GetMyTenantsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.GetMyTenantsReply;
  return proto.tenantmanager.GetMyTenantsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.GetMyTenantsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.GetMyTenantsReply}
 */
proto.tenantmanager.GetMyTenantsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tenantmanager.TenantInfo;
      reader.readMessage(value,proto.tenantmanager.TenantInfo.deserializeBinaryFromReader);
      msg.addTenants(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.GetMyTenantsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.GetMyTenantsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.GetMyTenantsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.GetMyTenantsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tenantmanager.TenantInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TenantInfo tenants = 1;
 * @return {!Array<!proto.tenantmanager.TenantInfo>}
 */
proto.tenantmanager.GetMyTenantsReply.prototype.getTenantsList = function() {
  return /** @type{!Array<!proto.tenantmanager.TenantInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tenantmanager.TenantInfo, 1));
};


/**
 * @param {!Array<!proto.tenantmanager.TenantInfo>} value
 * @return {!proto.tenantmanager.GetMyTenantsReply} returns this
*/
proto.tenantmanager.GetMyTenantsReply.prototype.setTenantsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tenantmanager.TenantInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tenantmanager.TenantInfo}
 */
proto.tenantmanager.GetMyTenantsReply.prototype.addTenants = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tenantmanager.TenantInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tenantmanager.GetMyTenantsReply} returns this
 */
proto.tenantmanager.GetMyTenantsReply.prototype.clearTenantsList = function() {
  return this.setTenantsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.GetMyTenantReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.GetMyTenantReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.GetMyTenantReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.GetMyTenantReq.toObject = function(includeInstance, msg) {
  var f, obj = {
tenantId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.GetMyTenantReq}
 */
proto.tenantmanager.GetMyTenantReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.GetMyTenantReq;
  return proto.tenantmanager.GetMyTenantReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.GetMyTenantReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.GetMyTenantReq}
 */
proto.tenantmanager.GetMyTenantReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.GetMyTenantReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.GetMyTenantReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.GetMyTenantReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.GetMyTenantReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.tenantmanager.GetMyTenantReq.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.GetMyTenantReq} returns this
 */
proto.tenantmanager.GetMyTenantReq.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.GetMyTenantReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.GetMyTenantReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.GetMyTenantReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.GetMyTenantReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tenant: (f = msg.getTenant()) && proto.tenantmanager.TenantInfo.toObject(includeInstance, f),
branding: (f = msg.getBranding()) && proto.tenantmanager.Branding.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.GetMyTenantReply}
 */
proto.tenantmanager.GetMyTenantReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.GetMyTenantReply;
  return proto.tenantmanager.GetMyTenantReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.GetMyTenantReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.GetMyTenantReply}
 */
proto.tenantmanager.GetMyTenantReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tenantmanager.TenantInfo;
      reader.readMessage(value,proto.tenantmanager.TenantInfo.deserializeBinaryFromReader);
      msg.setTenant(value);
      break;
    case 2:
      var value = new proto.tenantmanager.Branding;
      reader.readMessage(value,proto.tenantmanager.Branding.deserializeBinaryFromReader);
      msg.setBranding(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.GetMyTenantReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.GetMyTenantReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.GetMyTenantReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.GetMyTenantReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenant();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.tenantmanager.TenantInfo.serializeBinaryToWriter
    );
  }
  f = message.getBranding();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.tenantmanager.Branding.serializeBinaryToWriter
    );
  }
};


/**
 * optional TenantInfo tenant = 1;
 * @return {?proto.tenantmanager.TenantInfo}
 */
proto.tenantmanager.GetMyTenantReply.prototype.getTenant = function() {
  return /** @type{?proto.tenantmanager.TenantInfo} */ (
    jspb.Message.getWrapperField(this, proto.tenantmanager.TenantInfo, 1));
};


/**
 * @param {?proto.tenantmanager.TenantInfo|undefined} value
 * @return {!proto.tenantmanager.GetMyTenantReply} returns this
*/
proto.tenantmanager.GetMyTenantReply.prototype.setTenant = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tenantmanager.GetMyTenantReply} returns this
 */
proto.tenantmanager.GetMyTenantReply.prototype.clearTenant = function() {
  return this.setTenant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tenantmanager.GetMyTenantReply.prototype.hasTenant = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Branding branding = 2;
 * @return {?proto.tenantmanager.Branding}
 */
proto.tenantmanager.GetMyTenantReply.prototype.getBranding = function() {
  return /** @type{?proto.tenantmanager.Branding} */ (
    jspb.Message.getWrapperField(this, proto.tenantmanager.Branding, 2));
};


/**
 * @param {?proto.tenantmanager.Branding|undefined} value
 * @return {!proto.tenantmanager.GetMyTenantReply} returns this
*/
proto.tenantmanager.GetMyTenantReply.prototype.setBranding = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tenantmanager.GetMyTenantReply} returns this
 */
proto.tenantmanager.GetMyTenantReply.prototype.clearBranding = function() {
  return this.setBranding(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tenantmanager.GetMyTenantReply.prototype.hasBranding = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.TierUsage.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.TierUsage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.TierUsage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.TierUsage.toObject = function(includeInstance, msg) {
  var f, obj = {
tier: jspb.Message.getFieldWithDefault(msg, 1, 0),
capacity: jspb.Message.getFieldWithDefault(msg, 2, 0),
assigned: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.TierUsage}
 */
proto.tenantmanager.TierUsage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.TierUsage;
  return proto.tenantmanager.TierUsage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.TierUsage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.TierUsage}
 */
proto.tenantmanager.TierUsage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.tenantmanager.SeatTier} */ (reader.readEnum());
      msg.setTier(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCapacity(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssigned(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.TierUsage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.TierUsage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.TierUsage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.TierUsage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTier();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCapacity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAssigned();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional SeatTier tier = 1;
 * @return {!proto.tenantmanager.SeatTier}
 */
proto.tenantmanager.TierUsage.prototype.getTier = function() {
  return /** @type {!proto.tenantmanager.SeatTier} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.tenantmanager.SeatTier} value
 * @return {!proto.tenantmanager.TierUsage} returns this
 */
proto.tenantmanager.TierUsage.prototype.setTier = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 capacity = 2;
 * @return {number}
 */
proto.tenantmanager.TierUsage.prototype.getCapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.TierUsage} returns this
 */
proto.tenantmanager.TierUsage.prototype.setCapacity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 assigned = 3;
 * @return {number}
 */
proto.tenantmanager.TierUsage.prototype.getAssigned = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.TierUsage} returns this
 */
proto.tenantmanager.TierUsage.prototype.setAssigned = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.GetSeatUsageReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.GetSeatUsageReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.GetSeatUsageReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.GetSeatUsageReq.toObject = function(includeInstance, msg) {
  var f, obj = {
tenantId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.GetSeatUsageReq}
 */
proto.tenantmanager.GetSeatUsageReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.GetSeatUsageReq;
  return proto.tenantmanager.GetSeatUsageReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.GetSeatUsageReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.GetSeatUsageReq}
 */
proto.tenantmanager.GetSeatUsageReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.GetSeatUsageReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.GetSeatUsageReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.GetSeatUsageReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.GetSeatUsageReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.tenantmanager.GetSeatUsageReq.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.GetSeatUsageReq} returns this
 */
proto.tenantmanager.GetSeatUsageReq.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tenantmanager.GetSeatUsageReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.GetSeatUsageReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.GetSeatUsageReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.GetSeatUsageReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.GetSeatUsageReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tiersList: jspb.Message.toObjectList(msg.getTiersList(),
    proto.tenantmanager.TierUsage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.GetSeatUsageReply}
 */
proto.tenantmanager.GetSeatUsageReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.GetSeatUsageReply;
  return proto.tenantmanager.GetSeatUsageReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.GetSeatUsageReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.GetSeatUsageReply}
 */
proto.tenantmanager.GetSeatUsageReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tenantmanager.TierUsage;
      reader.readMessage(value,proto.tenantmanager.TierUsage.deserializeBinaryFromReader);
      msg.addTiers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.GetSeatUsageReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.GetSeatUsageReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.GetSeatUsageReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.GetSeatUsageReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTiersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tenantmanager.TierUsage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TierUsage tiers = 1;
 * @return {!Array<!proto.tenantmanager.TierUsage>}
 */
proto.tenantmanager.GetSeatUsageReply.prototype.getTiersList = function() {
  return /** @type{!Array<!proto.tenantmanager.TierUsage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tenantmanager.TierUsage, 1));
};


/**
 * @param {!Array<!proto.tenantmanager.TierUsage>} value
 * @return {!proto.tenantmanager.GetSeatUsageReply} returns this
*/
proto.tenantmanager.GetSeatUsageReply.prototype.setTiersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tenantmanager.TierUsage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tenantmanager.TierUsage}
 */
proto.tenantmanager.GetSeatUsageReply.prototype.addTiers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tenantmanager.TierUsage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tenantmanager.GetSeatUsageReply} returns this
 */
proto.tenantmanager.GetSeatUsageReply.prototype.clearTiersList = function() {
  return this.setTiersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.SetRoomSeatLimitsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.SetRoomSeatLimitsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.SetRoomSeatLimitsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.SetRoomSeatLimitsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
tenantId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountLimit: jspb.Message.getFieldWithDefault(msg, 2, 0),
premAccLimit: jspb.Message.getFieldWithDefault(msg, 3, 0),
futuresAccLimit: jspb.Message.getFieldWithDefault(msg, 4, 0),
releaseMode: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.SetRoomSeatLimitsReq}
 */
proto.tenantmanager.SetRoomSeatLimitsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.SetRoomSeatLimitsReq;
  return proto.tenantmanager.SetRoomSeatLimitsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.SetRoomSeatLimitsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.SetRoomSeatLimitsReq}
 */
proto.tenantmanager.SetRoomSeatLimitsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccountLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPremAccLimit(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFuturesAccLimit(value);
      break;
    case 5:
      var value = /** @type {!proto.tenantmanager.AccountReleaseMode} */ (reader.readEnum());
      msg.setReleaseMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.SetRoomSeatLimitsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.SetRoomSeatLimitsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.SetRoomSeatLimitsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.SetRoomSeatLimitsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPremAccLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getFuturesAccLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getReleaseMode();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.tenantmanager.SetRoomSeatLimitsReq.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.SetRoomSeatLimitsReq} returns this
 */
proto.tenantmanager.SetRoomSeatLimitsReq.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 account_limit = 2;
 * @return {number}
 */
proto.tenantmanager.SetRoomSeatLimitsReq.prototype.getAccountLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.SetRoomSeatLimitsReq} returns this
 */
proto.tenantmanager.SetRoomSeatLimitsReq.prototype.setAccountLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 prem_acc_limit = 3;
 * @return {number}
 */
proto.tenantmanager.SetRoomSeatLimitsReq.prototype.getPremAccLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.SetRoomSeatLimitsReq} returns this
 */
proto.tenantmanager.SetRoomSeatLimitsReq.prototype.setPremAccLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 futures_acc_limit = 4;
 * @return {number}
 */
proto.tenantmanager.SetRoomSeatLimitsReq.prototype.getFuturesAccLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.SetRoomSeatLimitsReq} returns this
 */
proto.tenantmanager.SetRoomSeatLimitsReq.prototype.setFuturesAccLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional AccountReleaseMode release_mode = 5;
 * @return {!proto.tenantmanager.AccountReleaseMode}
 */
proto.tenantmanager.SetRoomSeatLimitsReq.prototype.getReleaseMode = function() {
  return /** @type {!proto.tenantmanager.AccountReleaseMode} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.tenantmanager.AccountReleaseMode} value
 * @return {!proto.tenantmanager.SetRoomSeatLimitsReq} returns this
 */
proto.tenantmanager.SetRoomSeatLimitsReq.prototype.setReleaseMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.SetRoomSeatLimitsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.SetRoomSeatLimitsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.SetRoomSeatLimitsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.SetRoomSeatLimitsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.SetRoomSeatLimitsReply}
 */
proto.tenantmanager.SetRoomSeatLimitsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.SetRoomSeatLimitsReply;
  return proto.tenantmanager.SetRoomSeatLimitsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.SetRoomSeatLimitsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.SetRoomSeatLimitsReply}
 */
proto.tenantmanager.SetRoomSeatLimitsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.SetRoomSeatLimitsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.SetRoomSeatLimitsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.SetRoomSeatLimitsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.SetRoomSeatLimitsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.DedicatedEnvPool.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.DedicatedEnvPool.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.DedicatedEnvPool} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.DedicatedEnvPool.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
nickName: jspb.Message.getFieldWithDefault(msg, 2, ""),
accountLimit: jspb.Message.getFieldWithDefault(msg, 3, 0),
accountsCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
assignedTotal: jspb.Message.getFieldWithDefault(msg, 5, 0),
roomLimit: jspb.Message.getFieldWithDefault(msg, 6, 0),
ownerAllocatedTotal: jspb.Message.getFieldWithDefault(msg, 7, 0),
envType: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.DedicatedEnvPool}
 */
proto.tenantmanager.DedicatedEnvPool.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.DedicatedEnvPool;
  return proto.tenantmanager.DedicatedEnvPool.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.DedicatedEnvPool} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.DedicatedEnvPool}
 */
proto.tenantmanager.DedicatedEnvPool.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountLimit(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountsCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignedTotal(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRoomLimit(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOwnerAllocatedTotal(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnvType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.DedicatedEnvPool.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.DedicatedEnvPool.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.DedicatedEnvPool} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.DedicatedEnvPool.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNickName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountLimit();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAccountsCount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAssignedTotal();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRoomLimit();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getOwnerAllocatedTotal();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getEnvType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tenantmanager.DedicatedEnvPool.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.DedicatedEnvPool} returns this
 */
proto.tenantmanager.DedicatedEnvPool.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string nick_name = 2;
 * @return {string}
 */
proto.tenantmanager.DedicatedEnvPool.prototype.getNickName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.DedicatedEnvPool} returns this
 */
proto.tenantmanager.DedicatedEnvPool.prototype.setNickName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 account_limit = 3;
 * @return {number}
 */
proto.tenantmanager.DedicatedEnvPool.prototype.getAccountLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.DedicatedEnvPool} returns this
 */
proto.tenantmanager.DedicatedEnvPool.prototype.setAccountLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 accounts_count = 4;
 * @return {number}
 */
proto.tenantmanager.DedicatedEnvPool.prototype.getAccountsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.DedicatedEnvPool} returns this
 */
proto.tenantmanager.DedicatedEnvPool.prototype.setAccountsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 assigned_total = 5;
 * @return {number}
 */
proto.tenantmanager.DedicatedEnvPool.prototype.getAssignedTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.DedicatedEnvPool} returns this
 */
proto.tenantmanager.DedicatedEnvPool.prototype.setAssignedTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 room_limit = 6;
 * @return {number}
 */
proto.tenantmanager.DedicatedEnvPool.prototype.getRoomLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.DedicatedEnvPool} returns this
 */
proto.tenantmanager.DedicatedEnvPool.prototype.setRoomLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 owner_allocated_total = 7;
 * @return {number}
 */
proto.tenantmanager.DedicatedEnvPool.prototype.getOwnerAllocatedTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.DedicatedEnvPool} returns this
 */
proto.tenantmanager.DedicatedEnvPool.prototype.setOwnerAllocatedTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string env_type = 8;
 * @return {string}
 */
proto.tenantmanager.DedicatedEnvPool.prototype.getEnvType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.DedicatedEnvPool} returns this
 */
proto.tenantmanager.DedicatedEnvPool.prototype.setEnvType = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.ListTenantDedicatedEnvsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.ListTenantDedicatedEnvsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.ListTenantDedicatedEnvsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.ListTenantDedicatedEnvsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
tenantId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.ListTenantDedicatedEnvsReq}
 */
proto.tenantmanager.ListTenantDedicatedEnvsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.ListTenantDedicatedEnvsReq;
  return proto.tenantmanager.ListTenantDedicatedEnvsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.ListTenantDedicatedEnvsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.ListTenantDedicatedEnvsReq}
 */
proto.tenantmanager.ListTenantDedicatedEnvsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.ListTenantDedicatedEnvsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.ListTenantDedicatedEnvsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.ListTenantDedicatedEnvsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.ListTenantDedicatedEnvsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.tenantmanager.ListTenantDedicatedEnvsReq.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.ListTenantDedicatedEnvsReq} returns this
 */
proto.tenantmanager.ListTenantDedicatedEnvsReq.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tenantmanager.ListTenantDedicatedEnvsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.ListTenantDedicatedEnvsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.ListTenantDedicatedEnvsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.ListTenantDedicatedEnvsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.ListTenantDedicatedEnvsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
envsList: jspb.Message.toObjectList(msg.getEnvsList(),
    proto.tenantmanager.DedicatedEnvPool.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.ListTenantDedicatedEnvsReply}
 */
proto.tenantmanager.ListTenantDedicatedEnvsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.ListTenantDedicatedEnvsReply;
  return proto.tenantmanager.ListTenantDedicatedEnvsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.ListTenantDedicatedEnvsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.ListTenantDedicatedEnvsReply}
 */
proto.tenantmanager.ListTenantDedicatedEnvsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tenantmanager.DedicatedEnvPool;
      reader.readMessage(value,proto.tenantmanager.DedicatedEnvPool.deserializeBinaryFromReader);
      msg.addEnvs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.ListTenantDedicatedEnvsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.ListTenantDedicatedEnvsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.ListTenantDedicatedEnvsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.ListTenantDedicatedEnvsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnvsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tenantmanager.DedicatedEnvPool.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DedicatedEnvPool envs = 1;
 * @return {!Array<!proto.tenantmanager.DedicatedEnvPool>}
 */
proto.tenantmanager.ListTenantDedicatedEnvsReply.prototype.getEnvsList = function() {
  return /** @type{!Array<!proto.tenantmanager.DedicatedEnvPool>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tenantmanager.DedicatedEnvPool, 1));
};


/**
 * @param {!Array<!proto.tenantmanager.DedicatedEnvPool>} value
 * @return {!proto.tenantmanager.ListTenantDedicatedEnvsReply} returns this
*/
proto.tenantmanager.ListTenantDedicatedEnvsReply.prototype.setEnvsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tenantmanager.DedicatedEnvPool=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tenantmanager.DedicatedEnvPool}
 */
proto.tenantmanager.ListTenantDedicatedEnvsReply.prototype.addEnvs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tenantmanager.DedicatedEnvPool, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tenantmanager.ListTenantDedicatedEnvsReply} returns this
 */
proto.tenantmanager.ListTenantDedicatedEnvsReply.prototype.clearEnvsList = function() {
  return this.setEnvsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.SetRoomDedicatedEnvReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.SetRoomDedicatedEnvReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.SetRoomDedicatedEnvReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.SetRoomDedicatedEnvReq.toObject = function(includeInstance, msg) {
  var f, obj = {
tenantId: jspb.Message.getFieldWithDefault(msg, 1, ""),
dedicatedEnvId: jspb.Message.getFieldWithDefault(msg, 2, ""),
accountLimit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.SetRoomDedicatedEnvReq}
 */
proto.tenantmanager.SetRoomDedicatedEnvReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.SetRoomDedicatedEnvReq;
  return proto.tenantmanager.SetRoomDedicatedEnvReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.SetRoomDedicatedEnvReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.SetRoomDedicatedEnvReq}
 */
proto.tenantmanager.SetRoomDedicatedEnvReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDedicatedEnvId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.SetRoomDedicatedEnvReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.SetRoomDedicatedEnvReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.SetRoomDedicatedEnvReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.SetRoomDedicatedEnvReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDedicatedEnvId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountLimit();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.tenantmanager.SetRoomDedicatedEnvReq.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.SetRoomDedicatedEnvReq} returns this
 */
proto.tenantmanager.SetRoomDedicatedEnvReq.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string dedicated_env_id = 2;
 * @return {string}
 */
proto.tenantmanager.SetRoomDedicatedEnvReq.prototype.getDedicatedEnvId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.SetRoomDedicatedEnvReq} returns this
 */
proto.tenantmanager.SetRoomDedicatedEnvReq.prototype.setDedicatedEnvId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 account_limit = 3;
 * @return {number}
 */
proto.tenantmanager.SetRoomDedicatedEnvReq.prototype.getAccountLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.SetRoomDedicatedEnvReq} returns this
 */
proto.tenantmanager.SetRoomDedicatedEnvReq.prototype.setAccountLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.SetRoomDedicatedEnvReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.SetRoomDedicatedEnvReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.SetRoomDedicatedEnvReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.SetRoomDedicatedEnvReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.SetRoomDedicatedEnvReply}
 */
proto.tenantmanager.SetRoomDedicatedEnvReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.SetRoomDedicatedEnvReply;
  return proto.tenantmanager.SetRoomDedicatedEnvReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.SetRoomDedicatedEnvReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.SetRoomDedicatedEnvReply}
 */
proto.tenantmanager.SetRoomDedicatedEnvReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.SetRoomDedicatedEnvReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.SetRoomDedicatedEnvReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.SetRoomDedicatedEnvReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.SetRoomDedicatedEnvReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.UpdateBrandingReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.UpdateBrandingReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.UpdateBrandingReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.UpdateBrandingReq.toObject = function(includeInstance, msg) {
  var f, obj = {
tenantId: jspb.Message.getFieldWithDefault(msg, 1, ""),
branding: (f = msg.getBranding()) && proto.tenantmanager.Branding.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.UpdateBrandingReq}
 */
proto.tenantmanager.UpdateBrandingReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.UpdateBrandingReq;
  return proto.tenantmanager.UpdateBrandingReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.UpdateBrandingReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.UpdateBrandingReq}
 */
proto.tenantmanager.UpdateBrandingReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    case 2:
      var value = new proto.tenantmanager.Branding;
      reader.readMessage(value,proto.tenantmanager.Branding.deserializeBinaryFromReader);
      msg.setBranding(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.UpdateBrandingReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.UpdateBrandingReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.UpdateBrandingReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.UpdateBrandingReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBranding();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.tenantmanager.Branding.serializeBinaryToWriter
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.tenantmanager.UpdateBrandingReq.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.UpdateBrandingReq} returns this
 */
proto.tenantmanager.UpdateBrandingReq.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Branding branding = 2;
 * @return {?proto.tenantmanager.Branding}
 */
proto.tenantmanager.UpdateBrandingReq.prototype.getBranding = function() {
  return /** @type{?proto.tenantmanager.Branding} */ (
    jspb.Message.getWrapperField(this, proto.tenantmanager.Branding, 2));
};


/**
 * @param {?proto.tenantmanager.Branding|undefined} value
 * @return {!proto.tenantmanager.UpdateBrandingReq} returns this
*/
proto.tenantmanager.UpdateBrandingReq.prototype.setBranding = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tenantmanager.UpdateBrandingReq} returns this
 */
proto.tenantmanager.UpdateBrandingReq.prototype.clearBranding = function() {
  return this.setBranding(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tenantmanager.UpdateBrandingReq.prototype.hasBranding = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.UpdateBrandingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.UpdateBrandingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.UpdateBrandingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.UpdateBrandingReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.UpdateBrandingReply}
 */
proto.tenantmanager.UpdateBrandingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.UpdateBrandingReply;
  return proto.tenantmanager.UpdateBrandingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.UpdateBrandingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.UpdateBrandingReply}
 */
proto.tenantmanager.UpdateBrandingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.UpdateBrandingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.UpdateBrandingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.UpdateBrandingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.UpdateBrandingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.UploadBrandingAssetReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.UploadBrandingAssetReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.UploadBrandingAssetReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.UploadBrandingAssetReq.toObject = function(includeInstance, msg) {
  var f, obj = {
tenantId: jspb.Message.getFieldWithDefault(msg, 1, ""),
assetType: jspb.Message.getFieldWithDefault(msg, 2, 0),
contentType: jspb.Message.getFieldWithDefault(msg, 3, ""),
content: msg.getContent_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.UploadBrandingAssetReq}
 */
proto.tenantmanager.UploadBrandingAssetReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.UploadBrandingAssetReq;
  return proto.tenantmanager.UploadBrandingAssetReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.UploadBrandingAssetReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.UploadBrandingAssetReq}
 */
proto.tenantmanager.UploadBrandingAssetReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    case 2:
      var value = /** @type {!proto.tenantmanager.BrandingAssetType} */ (reader.readEnum());
      msg.setAssetType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentType(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.UploadBrandingAssetReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.UploadBrandingAssetReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.UploadBrandingAssetReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.UploadBrandingAssetReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAssetType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getContentType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.tenantmanager.UploadBrandingAssetReq.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.UploadBrandingAssetReq} returns this
 */
proto.tenantmanager.UploadBrandingAssetReq.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BrandingAssetType asset_type = 2;
 * @return {!proto.tenantmanager.BrandingAssetType}
 */
proto.tenantmanager.UploadBrandingAssetReq.prototype.getAssetType = function() {
  return /** @type {!proto.tenantmanager.BrandingAssetType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.tenantmanager.BrandingAssetType} value
 * @return {!proto.tenantmanager.UploadBrandingAssetReq} returns this
 */
proto.tenantmanager.UploadBrandingAssetReq.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string content_type = 3;
 * @return {string}
 */
proto.tenantmanager.UploadBrandingAssetReq.prototype.getContentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.UploadBrandingAssetReq} returns this
 */
proto.tenantmanager.UploadBrandingAssetReq.prototype.setContentType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bytes content = 4;
 * @return {!(string|Uint8Array)}
 */
proto.tenantmanager.UploadBrandingAssetReq.prototype.getContent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes content = 4;
 * This is a type-conversion wrapper around `getContent()`
 * @return {string}
 */
proto.tenantmanager.UploadBrandingAssetReq.prototype.getContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getContent()));
};


/**
 * optional bytes content = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getContent()`
 * @return {!Uint8Array}
 */
proto.tenantmanager.UploadBrandingAssetReq.prototype.getContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.tenantmanager.UploadBrandingAssetReq} returns this
 */
proto.tenantmanager.UploadBrandingAssetReq.prototype.setContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.UploadBrandingAssetReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.UploadBrandingAssetReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.UploadBrandingAssetReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.UploadBrandingAssetReply.toObject = function(includeInstance, msg) {
  var f, obj = {
url: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.UploadBrandingAssetReply}
 */
proto.tenantmanager.UploadBrandingAssetReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.UploadBrandingAssetReply;
  return proto.tenantmanager.UploadBrandingAssetReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.UploadBrandingAssetReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.UploadBrandingAssetReply}
 */
proto.tenantmanager.UploadBrandingAssetReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.UploadBrandingAssetReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.UploadBrandingAssetReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.UploadBrandingAssetReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.UploadBrandingAssetReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.tenantmanager.UploadBrandingAssetReply.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.UploadBrandingAssetReply} returns this
 */
proto.tenantmanager.UploadBrandingAssetReply.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.ReleaseClosedRoomAccountsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.ReleaseClosedRoomAccountsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
tenantId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.ReleaseClosedRoomAccountsReq}
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.ReleaseClosedRoomAccountsReq;
  return proto.tenantmanager.ReleaseClosedRoomAccountsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.ReleaseClosedRoomAccountsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.ReleaseClosedRoomAccountsReq}
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.ReleaseClosedRoomAccountsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.ReleaseClosedRoomAccountsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReq.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tenantmanager.ReleaseClosedRoomAccountsReq} returns this
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReq.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tenantmanager.ReleaseClosedRoomAccountsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tenantmanager.ReleaseClosedRoomAccountsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
released: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tenantmanager.ReleaseClosedRoomAccountsReply}
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tenantmanager.ReleaseClosedRoomAccountsReply;
  return proto.tenantmanager.ReleaseClosedRoomAccountsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tenantmanager.ReleaseClosedRoomAccountsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tenantmanager.ReleaseClosedRoomAccountsReply}
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReleased(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tenantmanager.ReleaseClosedRoomAccountsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tenantmanager.ReleaseClosedRoomAccountsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReleased();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 released = 1;
 * @return {number}
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReply.prototype.getReleased = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.tenantmanager.ReleaseClosedRoomAccountsReply} returns this
 */
proto.tenantmanager.ReleaseClosedRoomAccountsReply.prototype.setReleased = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.tenantmanager.SeatTier = {
  SEAT_TIER_UNSPECIFIED: 0,
  SEAT_TIER_STANDARD: 1,
  SEAT_TIER_PREMIUM: 2,
  SEAT_TIER_DEDICATED: 3,
  SEAT_TIER_FUTURES: 4
};

/**
 * @enum {number}
 */
proto.tenantmanager.AccountReleaseMode = {
  ACCOUNT_RELEASE_MODE_UNSPECIFIED: 0,
  ACCOUNT_RELEASE_MODE_UNLINK: 1,
  ACCOUNT_RELEASE_MODE_DELETE: 2
};

/**
 * @enum {number}
 */
proto.tenantmanager.BrandingAssetType = {
  BRANDING_ASSET_UNSPECIFIED: 0,
  BRANDING_ASSET_LOGO: 1,
  BRANDING_ASSET_FAVICON: 2
};

goog.object.extend(exports, proto.tenantmanager);
